import React from 'react';
import { Redirect } from 'react-router-dom';

export const redirect = ({ from: fromPath, to: toPath }) => ({
  path: fromPath,
  component: () => <Redirect from={fromPath} to={toPath} />
});
